import { Chip, ChipExtendedProps } from '../../../chip/Chip';
import { Tooltip } from '../../../tooltip/Tooltip';
import { COMING_SOON_DESCRIPTION } from '../../constants';

export function ComingSoonChip(props: Partial<ChipExtendedProps>) {
  return (
    <Tooltip dataId='' title={COMING_SOON_DESCRIPTION}>
      <Chip dataId='' label='Coming Soon' {...props} />
    </Tooltip>
  );
}
